import {useEffect, useState} from 'react';

import WatchLaterIcon from '@mui/icons-material/WatchLater';
import {Typography, useTheme} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';
import Lottie from 'lottie-react';

import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import animationFile from '../../../../../lotties/spinner/whiteSpinnerAnimation.json';
import {formatDuration} from '../../../../../utils';
import Button from '../../../../form/buttons/Button/Button';
import CategoryAccordionIcon from '../../../shared/CategoryAccordionIcon/CategoryAccordionIcon';
import HistoryTitle from '../HistoryTitle/HistoryTitle';
import SingleUpdateHistoryBlockContainer from '../SingleUpdateHistoryBlockContainer/SingleUpdateHistoryBlockContainer';

const UpdateDuration = muiStyled(Typography)(({theme}) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
  lineHeight: 1
}));

const WhiteSpinner = () => <Lottie data-testid="lottie" style={{height: 19, width: 17}} loop animationData={animationFile} />;

const UpdateInProgressBlock = () => {
  const {currentReportJobUpdate, cancelDatasetRefresh} = useReportParameters();
  const theme = useTheme();

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const handleCancelUpdateButtonClick = e => {
    e.stopPropagation();
    cancelDatasetRefresh();
  };

  const updateJobStarted = currentReportJobUpdate?.startTime;

  return (
    <SingleUpdateHistoryBlockContainer
      sx={{
        border: '1px dashed lightgray',
        background: '#FAFAFA'
      }}
    >
      <Grid container gap={2} p={2} alignItems="center">
        <Grid item>
          <CategoryAccordionIcon color={theme.palette.grey.A700} customIcon={<WhiteSpinner />} />
        </Grid>
        <Grid item xs>
          <HistoryTitle>Actualisation en cours</HistoryTitle>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" gap={0.5}>
            <Grid item>
              <WatchLaterIcon color="grey" sx={{fontSize: 13}} />
            </Grid>
            <UpdateDuration>{updateJobStarted ? formatDuration(currentReportJobUpdate?.startTime, time) : <CircularProgress size={12} color="grey" />}</UpdateDuration>
            <Button disabled={!updateJobStarted} variant="contained" color="error" onClick={handleCancelUpdateButtonClick} size="small" sx={{fontSize: 11.5, ml: 1}}>
              Annuler
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </SingleUpdateHistoryBlockContainer>
  );
};

export default UpdateInProgressBlock;
